import { createSelector } from '@reduxjs/toolkit';
import { PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import { selectTotalAmountInQueue } from '../_redux-groups';
import { getPhotosStatus } from '../_redux-photos';

export const getProjectExportStatus = (state: PhotoPrintsPdpState) => {

    const statuses = [
        selectQueueStatus(state),
        getPhotosStatus(state),
        state.projectLoading.loadStatus
    ];

    if (statuses.every(s => s === 'ready')) {
        return 'ready';
    } else if (statuses.includes('error')) {
        return 'error';
    } else {
        return 'pending';
    }
};

const selectQueueStatus = createSelector([
    selectTotalAmountInQueue
], (amountInQueue) => amountInQueue === 0 ? 'ready' : 'pending');